import { COVER_TO_CLASS_TYPE, COVER_TO_RISK_CLASS } from 'constants/domain-specific';
import { Cover, DynamicCoverQuestion, DynamicCoverQuestionID } from 'types/cover';
import { Clause } from 'types/policy';

import { getDynamicCoverQuestionClauseCode } from './getDynamicCoverQuestionClauseCode';

/**
 * @description
 * Returns a clause for a specific dynamic cover question if the question has been
 * answered (in the coverDetails slice)and if a clauseCode can be found. If either of these
 * conditions fail, an empty array will be returned.
 */
export const generateClauseFromDynamicCoverQuestion = (
  dynamicCoverQuestions: DynamicCoverQuestion[],
  question: number | string | null,
  cover: Cover,
  questionID: DynamicCoverQuestionID
): [Clause] | [] => {
  if (!question) return [];
  const clauseCode = getDynamicCoverQuestionClauseCode(dynamicCoverQuestions, cover, questionID);
  if (clauseCode) {
    return [
      {
        clauseWording: [
          {
            riskClass: COVER_TO_RISK_CLASS[cover],
            premiumClass: COVER_TO_CLASS_TYPE[cover],
            clauseCode,
          },
        ],
      },
    ];
  }

  return [];
};
